import React from 'react';
import { Button } from '@/components/ui/button';
import { logStructured } from '@/lib/networkLog';
import { isChunkLoadError } from '@/routes/lazyPage';

/**
 * Captura errores de render en páginas críticas (no sustituye manejo de errores async).
 */
export default class CriticalPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, _errorInfo) {
    logStructured('error', {
      component: this.props.component ?? 'CriticalPageErrorBoundary',
      error:
        typeof error?.message === 'string'
          ? error.message
          : error != null
            ? String(error)
            : 'unknown',
      chunkLoad: isChunkLoadError(error),
    });
    if (isChunkLoadError(error) && typeof window !== 'undefined') {
      window.setTimeout(() => window.location.reload(), 400);
    }
  }

  render() {
    if (this.state.hasError) {
      const chunkStale = isChunkLoadError(this.state.error);
      return (
        <div className="min-h-[50vh] flex flex-col items-center justify-center gap-6 p-8 text-center max-w-md mx-auto">
          <div className="space-y-2">
            <p className="text-lg font-semibold text-foreground">Tuvimos un inconveniente</p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {chunkStale
                ? 'Hay una versión nueva de SoluQR. Recargá la página para actualizar el panel.'
                : 'Algo no salió como esperábamos en esta pantalla. Podés recargar, volver al inicio o ver el estado del sistema.'}
            </p>
          </div>
          <div className="flex flex-col w-full gap-2 sm:flex-row sm:justify-center">
            <Button
              type="button"
              variant="default"
              className="w-full sm:w-auto"
              onClick={() => {
                window.location.reload();
              }}
            >
              Recargar
            </Button>
            <Button type="button" variant="outline" className="w-full sm:w-auto" asChild>
              <a href="/">Ir al inicio</a>
            </Button>
            <Button type="button" variant="ghost" className="w-full sm:w-auto" asChild>
              <a href="/status">Estado del sistema</a>
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
